import getPathReduxUtil from 'modules/redux/utils/get-path'
import { getObjectUtil } from 'packages/src'

function getInstanceReduxUtil (state, instance) {
  if (!instance) {
    return
  }
  return getObjectUtil(state, getPathReduxUtil(instance))
}

export {
  getInstanceReduxUtil
}
